import { connect } from 'react-redux';
import { actions } from "./UserRoleManagementActions";
import UserRoleManagement from './UserRoleManagement';

const mapStateToProps = (state) => {
  const allRoles = state.UserRoleManagementReducer.allRolesList || [];
  const entityUserRoles = state.UserRoleManagementReducer.entityUserRolesList || [];

  return {
    allRoles,
    entityUserRoles,
  };
};

export default connect(mapStateToProps, actions)(UserRoleManagement);